import Cookies from "js-cookie";
export default function getCookie(cookieName) {
    const cookieValue = Cookies.get(cookieName);
    if (cookieValue === "" || cookieValue === undefined) {
        return null;
    }
    return cookieValue;
}
